<template>
<v-card
    max-width="374"
    style="margin-left: auto; margin-right: auto; margin-bottom: 15px;"
>

<v-img
    :src="require('@/assets/tasting/' + hero_src)"
></v-img>


<div
    style="margin-top: 15px; margin-left: 15px; font-weight: 700"
>
    {{title}}
</div>

<v-card-text>
    <div>{{desc}}</div>
</v-card-text>
<v-divider/>
<v-card-actions>
    <v-btn
    color="deep-purple lighten-2"
    text
    @click="onClickNotImplemented"
    >
    Shop
    </v-btn>
    <v-btn
    color="#5C215F"
    text
    @click="onClickNotImplemented"
    >
    Tasting Notes
    </v-btn>

</v-card-actions>
</v-card>
</template>

<script>
export default {
    props: {
        hero_src: {
            type: String,
            default: function() { return ""; }
        },

        title: {
            type: String,
            default: function() { return ""; }
        },

        desc: {
            type: String,
            default: function() { return ""; }
        },
    },

    methods: {
        onClickNotImplemented() {
            this.$rc.snackbar('For Demonstration Purposes Only - Not Implemented');
        }
    },
}
</script>

<style lang="scss" scoped>

</style>